export const api = 'https://uat-jkseeds-api.loyaltyprogramz.com/api/v1/'

export const av = process.env.REACT_APP_av;
export const pt = process.env.REACT_APP_pt;
export const did = process.env.REACT_APP_did;
export const country = process.env.REACT_APP_country;
export const dp = process.env.REACT_APP_dp;
